import { Empty, Input, Skeleton } from 'antd';
import { debounce } from 'lodash';
import { FC, FormEventHandler, useMemo, useState } from 'react';
import { EasyField } from 'react-antd-formutil';
import { RightOutlined, SearchOutlined } from '@ant-design/icons';
import Card from 'components/Card';
import ErrorBox from 'components/ErrorBox';
import { useBrokerList } from 'modules/Transfer/hooks';
import { BrokerData } from 'modules/Transfer/type';
import { TransferFormProps } from 'modules/Transfer/withTransferForm';
import { otherBrokerOption } from '../../helper';
import { BrokerPageFormutil } from '../../type';
import style from './style.scss';

const Broker: FC<TransferFormProps<BrokerPageFormutil>> = ({ $formutil, onSubmit }) => {
    const [searchBroker, setSearchBroker] = useState<string>('');
    const { $setValues } = $formutil;
    const { data, error, isLoading, mutate } = useBrokerList({ searchBroker, getAllBroker: false });
    const brokerList = useMemo<BrokerData[]>(() => {
        let list: BrokerData[] = [];

        if (data?.items?.length) {
            list = data.items;

            // 如果用户没有输入任何搜索内容, 则包含全部列表和other
            if (!searchBroker) {
                list = list.concat(otherBrokerOption);
            }
        }

        return list;
    }, [data, searchBroker]);
    // 防止输入框输入触发接口请求过于频繁, 应该使用防抖, 而非节流
    const handleSearch: FormEventHandler<HTMLInputElement> = useMemo(
        () =>
            debounce(event => {
                const target = event.target as HTMLInputElement;

                setSearchBroker(target.value);
            }, 300),
        []
    );
    const handleSelectBroker = async (broker: BrokerData) => {
        // 这里一定要等到设置完broker_id后, 再进行onSubmit处理, 因为onSubmit中会直接把当前页面的表单值写进缓存
        await $setValues({ broker_id: broker.id });

        onSubmit('../check');
    };
    const renderBrokerList = () => {
        if (error && !data) {
            return <ErrorBox error={error} onClick={() => mutate()} />;
        }

        if (isLoading) {
            return <Skeleton active />;
        }

        if (!brokerList.length) {
            return <Empty description={__('暂无数据')} image={Empty.PRESENTED_IMAGE_SIMPLE} />;
        }

        return (
            <div className={style.list}>
                {brokerList.map(item => (
                    <div key={item.broker} className={style.brokerItem}>
                        <div className={style.brokerContent} onClick={() => handleSelectBroker(item)}>
                            <div className={style.brokerLogo} style={{ backgroundImage: `url("${item.logo}")` }}></div>
                            <div className="mr-4">{item.broker}</div>
                            <RightOutlined className={style.arrow} />
                        </div>
                    </div>
                ))}
                <EasyField name="broker_id" type="hidden" />
            </div>
        );
    };

    return (
        <Card form>
            <div className={style.header}>
                <h3 className="transfer-title">{__("Select the broker you'd like to transfer from")}</h3>
                <Input
                    className={style.search}
                    prefix={<SearchOutlined />}
                    placeholder={__('Search')}
                    onInput={handleSearch}
                />
            </div>
            {renderBrokerList()}
        </Card>
    );
};

export default Broker;
